"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const chevron_down_svg_1 = __importDefault(require("@@/assets/svgs/chevron_down.svg"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = ({ elementRef, dependency = null, bottomElementId = '', }) => {
    const [expandRequired, setExpandRequired] = (0, react_1.useState)(false);
    const [expand, setExpand] = (0, react_1.useState)(true);
    const FOLD_HEIGHT = 800;
    (0, react_1.useEffect)(() => {
        if (dependency && (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current)) {
            const imgLength = (String(dependency).match(/<img/g) || []).length;
            if ((elementRef === null || elementRef === void 0 ? void 0 : elementRef.current.offsetHeight) > 800 || imgLength > 3) {
                setExpandRequired(true);
                setExpand(false);
            }
        }
    }, [dependency]);
    (0, react_1.useEffect)(() => {
        if (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) {
            if (expand) {
                elementRef.current.style.maxHeight = 'unset';
            }
            else {
                elementRef.current.style.maxHeight = `${FOLD_HEIGHT}px`;
            }
        }
    }, [expand]);
    const scrollToShowMoreBtn = () => {
        var _a;
        if (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) {
            let elementOffsetTop = elementRef.current.offsetTop;
            let windowHeight = window.innerHeight;
            let bottomElementHeight = ((_a = document.getElementById(bottomElementId)) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
            window.scrollTo(0, elementOffsetTop + FOLD_HEIGHT - windowHeight + bottomElementHeight);
        }
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(ShowMoreButtonDiv, Object.assign({ id: "show_more_btn", expandRequired: expandRequired, expand: expand }, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ onClick: () => {
                if (expand)
                    scrollToShowMoreBtn();
                setExpand(!expand);
            } }, { children: [expand ? (0, jsx_runtime_1.jsx)("span", { children: t('접기') }) : (0, jsx_runtime_1.jsx)("span", { children: t('펼치기') }), (0, jsx_runtime_1.jsx)(chevron_down_svg_1.default, { css: {
                        width: '20px',
                        height: '20px',
                        marginRight: '-6px',
                        transform: `rotate(${expand ? 180 : 0}deg)`,
                    } })] })) })));
};
const ShowMoreButtonDiv = 
// eslint-disable-next-line prettier/prettier
styled_1.default.div `
    position: sticky;
    bottom: -20px;
    display: ${props => (props.expandRequired ? 'inherit' : 'none')};
    padding: 160px 20px 20px;
    margin: ${props => (props.expand ? '0 -20px -20px' : '0 -20px')};
    background: linear-gradient(
      0deg,
      rgb(255, 255, 255) 17.03%,
      rgba(255, 255, 255, 0.9) 80%,
      rgba(255, 255, 255, 0) 100.27%
    );
    .MuiButton-root {
      width: 100%;
      height: 42px;
      border: 1px solid rgba(0, 0, 0, 0.8);
      border-radius: 6px;
      color: black;
      background-color: white !important;
      box-shadow: 0px 5px 10px rgb(0 0 0 / 15%);
      font-size: 15px;
      font-weight: 700;
    }
  `;
